import { Disclosure } from '@headlessui/react';
import { useState } from 'react';

export default function Holiday() {
  const [isOpen, setIsOpen] = useState(false);

  const currentDate = new Date();
  const dhakaDate = new Date('2025-06-03T14:00:00+06:00');
  const outsideDhakaDate = new Date('2025-06-02T14:00:00+06:00');
  const restartDate = new Date('2025-06-13T00:00:00+06:00');

  // Convert current date to Dhaka time zone
  const currentDateDhaka = new Date(currentDate.toLocaleString('en-US', { timeZone: 'Asia/Dhaka' })); const getDhakaMessage = () => {
    if (currentDateDhaka.getTime() < dhakaDate.getTime()) {
      return `${dhakaDate.toLocaleDateString('en-US', { month: 'long' })} ${dhakaDate.getDate().toString().padStart(2, '0')}; ${dhakaDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`;
    } else if (currentDateDhaka.getTime() >= dhakaDate.getTime() && currentDateDhaka.getTime() < restartDate.getTime()) {
      return 'Delivery Closed for Eid';
    } else {
      return 'Deliveries Restarted. Order Any time';
    }
  }; const getOutsideDhakaMessage = () => {
    if (currentDateDhaka.getTime() < outsideDhakaDate.getTime()) {
      return `${outsideDhakaDate.toLocaleDateString('en-US', { month: 'long' })} ${outsideDhakaDate.getDate().toString().padStart(2, '0')}; ${outsideDhakaDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}`;
    } else if (currentDateDhaka.getTime() >= outsideDhakaDate.getTime() && currentDateDhaka.getTime() < restartDate.getTime()) {
      return 'Delivery Closed for Eid';
    } else {
      return 'Deliveries Restarted. Order Any time';
    }
  };
  return (
    <div className="flex  justify-center py-4 sm:py-6 md:py-8 px-2 sm:px-4 bg-gradient-to-br from-red-100 to-violet-100 rounded-lg">
      <div className="max-w-md w-full">
        <Disclosure
          as="div"
          className="relative bg-white shadow-xl sm:shadow-2xl rounded-xl sm:rounded-2xl overflow-hidden"
          defaultOpen={true}
          open={isOpen}
          onChange={() => setIsOpen(!isOpen)}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-indigo-600 opacity-20 pointer-events-none"></div>
          <Disclosure.Button className="flex justify-between items-center w-full px-3 sm:px-4 md:px-6 py-3 sm:py-4 text-sm sm:text-lg font-bold text-left text-white bg-gradient-to-r from-red-500 to-violet-600 hover:from-red-600 hover:to-violet-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-red-500 focus-visible:ring-opacity-50 transition duration-300 ease-in-out">
            <span className="text-sm sm:text-lg font-extrabold tracking-tight">
              Eid Delivery Schedule
            </span>
          </Disclosure.Button>
          <Disclosure.Panel className="px-3 sm:px-4 md:px-6 py-4 sm:py-6">
            <div className="overflow-x-auto">
              <table className="w-full text-xs sm:text-sm md:text-base text-left text-gray-600">
                <thead className="text-xs sm:text-sm md:text-base text-gray-800 uppercase bg-gradient-to-r from-red-100 to-indigo-100">
                  <tr>
                    <th scope="col" className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4">
                      Delivery Before Eid if
                    </th>
                    <th scope="col" className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4">
                      Order is placed before
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-white border-b border-red-200 hover:bg-red-50 transition duration-300 ease-in-out text-xs sm:text-sm md:text-lg">
                    <td className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4">Inside Dhaka</td>
                    <td className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4">{getDhakaMessage()}</td>
                  </tr>
                  <tr className="bg-purple-50 border-b border-purple-200 hover:bg-indigo-100 transition duration-300 ease-in-out text-xs sm:text-sm md:text-lg">
                    <td className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4">Outside Dhaka</td>
                    <td className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4">{getOutsideDhakaMessage()}</td>
                  </tr>
                  {currentDate.getTime() < restartDate.getTime() && (
                    <tr className="bg-white">
                      <td
                        colSpan="2"
                        className="px-2 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4 text-center italic text-xs sm:text-sm md:text-base text-gray-800"
                      >
                        Deliveries restart on {restartDate.toLocaleDateString('en-US', { month: 'long' })} {restartDate.getDate().toString().padStart(2, '0')} <br />
                        Warehouse Pickup available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Disclosure.Panel>
        </Disclosure>
      </div>
    </div>
  );
}